// extracted by mini-css-extract-plugin
module.exports = {"events-page-container":"Events_events-page-container__2EIod","events-header":"Events_events-header__ew1B-"};